module.exports = __webpack_public_path__ + "static/media/heeros_is_now_finago.717fd91e.png";